





































































import { Component, Vue } from 'vue-property-decorator';
import play from '@/resources/directives/play';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import FooterButton from '@/components/FooterButton.vue';
import CameraPageIntroductionPcBookImages from '@/components/CameraPageIntroductionPcBookImages.vue';
import CameraPageIntroductionPcCardImages from '@/components/CameraPageIntroductionPcCardImages.vue';

@Component({
  components: {
    CameraPageHeader,
    FooterButton,
    CameraPageIntroductionPcBookImages,
    CameraPageIntroductionPcCardImages
  },
  directives: {
    play
  }
})
export default class CameraChildIntroductionNormal extends Vue {
  private scrollerHeight: number = 0;
  private dynamicAreaHeight: number = 0;

  private get introductionMovieSrc(): string {
    if (!this.$store.state.camera.i18nKeyIntroductionMovieString) return '';
    return this.$t(this.$store.state.camera.i18nKeyIntroductionMovieString) as string;
  }

  private get introductionImageSrc(): string {
    if (!this.$store.state.camera.i18nKeyIntroductionImage1String) return '';
    return this.$t(this.$store.state.camera.i18nKeyIntroductionImage1String) as string;
  }

  private get isPC(): boolean {
    return this.$store.getters['camera/isPC'];
  }

  private get isGeneralBook(): boolean {
    return this.$store.getters['camera/isGeneralBook'];
  }

  private get isBookType(): boolean {
    return this.$store.getters['camera/isBookType'];
  }

  private get isIdDocDiagonal(): boolean {
    return this.$store.getters['camera/isIdDocDiagonal'];
  }

  private get isIdDocFront(): boolean {
    return this.$store.getters['camera/isIdDocFront'];
  }

  private get isIdDocBack(): boolean {
    return this.$store.getters['camera/isIdDocBack'];
  }

  private get introductionImageSrcset(): string {
    const img1: string = this.$t(this.$store.state.camera.i18nKeyIntroductionImage1String) as string;
    const img2: string = this.$t(this.$store.state.camera.i18nKeyIntroductionImage2String) as string;
    const img3: string = this.$t(this.$store.state.camera.i18nKeyIntroductionImage3String) as string;
    const img4: string = this.$t(this.$store.state.camera.i18nKeyIntroductionImage4String) as string;
    return `
      ${img1 ? `${img1} 1x,` : ''}
      ${img2 ? `${img2} 2x,` : ''}
      ${img3 ? `${img3} 3x,` : ''}
      ${img4 ? `${img4} 4x,` : ''}
    `;
  }

  public get photoHeight(): number {
    const displayWidth: number = this.$store.state.camera.displayWidth;
    const displayHeight: number = this.$store.state.camera.displayHeight;
    if (displayWidth <= 0 || displayHeight <= 0) return 0;
    // 画面高さから取りうる画像高さ
    const pageHeaderHeight: number = this.$store.state.camera.headerHeight;
    const totalHeight: number = pageHeaderHeight + this.dynamicAreaHeight;
    const maxPhotoHeight: number = displayHeight - totalHeight;
    // 画面幅から計算する画像高さ
    const photoAspectRatio: number = 4 / 3;
    const photoMarginHorizontal: number = 20;
    const basePhotoWidth: number = Math.min(displayWidth - photoMarginHorizontal * 2, 500);
    const basePhotoHeight: number = basePhotoWidth / photoAspectRatio;
    // 画像高さを計算する
    const photoHeight: number = Math.min(basePhotoHeight, maxPhotoHeight);
    const minPhotoHeight: number = 100;
    return Math.max(photoHeight, minPhotoHeight);
  }

  private get isScroll(): boolean {
    return this.scrollerHeight > this.$store.state.camera.displayHeight;
  }

  private get showPageContentsTitle(): boolean {
    // 汎用紙書類は斜めの時だけ表示する
    if (this.isGeneralBook && !this.isIdDocDiagonal) {
      return false;
    }

    return true;
  }

  private get descriptionList(): string[] {
    const key: string = this.$store.state.camera.i18nKeyIntroductionDescriptionArray;

    let list = (this.$t(key) as { [key: number]: string }) as string[];

    // json形式のi18n辞書ファイルで、配列形式の文言の中の変数は$t関数で置き換えられないので、ここで置換する
    list = list.map(item => item.replace('{documentName}', this.$store.state.camera.documentName));

    return list;
  }

  public mounted(): void {
    this.calcDynamicAreaHeight();
  }

  public updated(): void {
    this.calcDynamicAreaHeight();
  }

  private calcDynamicAreaHeight(): void {
    if (!this.$el) return;
    const scroller: HTMLDivElement = this.$el.getElementsByClassName('page-scroller').item(0) as HTMLDivElement;
    const contentHeader: HTMLDivElement = this.$el.getElementsByClassName('page-contents-title-container').item(0) as HTMLDivElement; // eslint-disable-line prettier/prettier
    const contentFooter: HTMLDivElement = this.$el
      .getElementsByClassName(this.isGeneralBook ? 'introduction-descriptions' : 'page-contents-description')
      .item(0) as HTMLDivElement;
    const pageFooter: HTMLDivElement = this.$el.getElementsByClassName('page-footer').item(0) as HTMLDivElement;
    const scrollerRect: DOMRect = scroller.getBoundingClientRect() as DOMRect;
    const contentHeaderRect: DOMRect = contentHeader.getBoundingClientRect() as DOMRect;
    const contentFooterRect: DOMRect = contentFooter.getBoundingClientRect() as DOMRect;
    const pageFooterRect: DOMRect = pageFooter.getBoundingClientRect() as DOMRect;
    this.scrollerHeight = scrollerRect.height;
    this.dynamicAreaHeight = contentHeaderRect.height + contentFooterRect.height + pageFooterRect.height;
  }
}
